import FieldProcessEngineJob from 'library/src/processing/models/FieldProcessEngineJob';
import ProcessEngineType from 'library/src/processing/models/ProcessEngineType';
import ProcessingType from 'library/src/processing/models/ProcessingType';
import { FieldStatisticRecord } from 'library/src/statistic/models/FieldStatisticRecord';
import StatisticIndicatorType from 'library/src/statistic/models/StatisticIndicatorType';
import { ProcessExecuteForm } from '../models/ProcessExecuteForm';

export const LOAD_PROCESS_ENGINE_JOBS = 'LOAD_PROCESS_ENGINE_JOBS';
export interface LoadProcessEngineJobsAction {
  type: typeof LOAD_PROCESS_ENGINE_JOBS;
  payload: {
    processEngineType: ProcessEngineType;
  };
}

export const LOAD_PROCESS_ENGINE_JOBS_SUCCESS =
  'LOAD_PROCESS_ENGINE_JOBS_SUCCESS';
export interface LoadProcessEngineJobsSuccessAction {
  type: typeof LOAD_PROCESS_ENGINE_JOBS_SUCCESS;
  payload: {
    jobs: {[key: string]: FieldProcessEngineJob};
  };
}

export const ON_SELECT_PROCESS_ENGINE = 'ON_SELECT_PROCESS_ENGINE';
export interface OnSelectProcessEngineAction {
  type: typeof ON_SELECT_PROCESS_ENGINE;
  payload: {
    processEngineType: ProcessEngineType | null;
  };
}

export const GET_STATISTICS = 'GET_STATISTICS';
export interface GetStatisticsAction {
  type: typeof GET_STATISTICS;
  payload: {
    processingType: ProcessingType;
    indicator: StatisticIndicatorType;
    campaignId: string;
    fieldId: string;
  }
}

export const GET_STATISTICS_SUCCESS = 'GET_STATISTICS_SUCCESS';
export interface GetStatisticsSuccessAction {
  type: typeof GET_STATISTICS_SUCCESS;
  payload: {
    data: {[key: string]: FieldStatisticRecord}
  }
}

export const ON_SELECT_INDICATOR = 'ON_SELECT_INDICATOR';
export interface OnSelectIndicatorAction {
  type: typeof ON_SELECT_INDICATOR;
  payload: {
    indicator: StatisticIndicatorType | null;
  };
}

export const ON_SELECT_STATISTIC_RECORD = 'ON_SELECT_STATISTIC_RECORD';
export interface OnSelectStatisticRecordAction {
  type: typeof ON_SELECT_STATISTIC_RECORD;
  payload: {
    statisticRecord: FieldStatisticRecord | null;
  };
}

export const EXECUTE_PROCESSING_JOB = 'EXECUTE_PROCESSING_JOB';
export interface ExecuteProcessingJobAction {
    type: typeof EXECUTE_PROCESSING_JOB;
    payload: ProcessExecuteForm;
}
export type VisioCropActionTypes =
  | LoadProcessEngineJobsAction
  | LoadProcessEngineJobsSuccessAction
  | OnSelectProcessEngineAction
  | GetStatisticsAction
  | GetStatisticsSuccessAction
  | OnSelectIndicatorAction
  | OnSelectStatisticRecordAction
  | ExecuteProcessingJobAction;
export const visioCropActions = {

    executeProcessJob: (
    form: ProcessExecuteForm,
  ): ExecuteProcessingJobAction => ({
    type: EXECUTE_PROCESSING_JOB,
    payload: form,
  }),
    onSelectStatisticRecord: (
    statisticRecord: FieldStatisticRecord | null,
  ): OnSelectStatisticRecordAction => ({
    type: ON_SELECT_STATISTIC_RECORD,
    payload: {
      statisticRecord,
    },
  }),
    onSelectIndicator: (
    indicator: StatisticIndicatorType | null,
  ): OnSelectIndicatorAction => ({
    type: ON_SELECT_INDICATOR,
    payload: {
      indicator,
    },
  }),
    getStatistics: (
    indicator: StatisticIndicatorType,
    processingType: ProcessingType,
    campaignId: string,
    fieldId: string,
  ): GetStatisticsAction => ({
    type: GET_STATISTICS,
    payload: {
      indicator,
      processingType,
      campaignId,
      fieldId,
    },
  }),
  getStatisticsSuccess: (
    data: {[key: string]: FieldStatisticRecord},
  ): GetStatisticsSuccessAction => ({
    type: GET_STATISTICS_SUCCESS,
    payload: {
      data,
    },
  }),
  onSelectProcessEngine: (
    processEngineType: ProcessEngineType | null,
  ): OnSelectProcessEngineAction => ({
    type: ON_SELECT_PROCESS_ENGINE,
    payload: {
      processEngineType,
    },
  }),
  loadProcessEngineJobs: (
    processEngineType: ProcessEngineType,
  ): LoadProcessEngineJobsAction => ({
    type: LOAD_PROCESS_ENGINE_JOBS,
    payload: {
      processEngineType,
    },
  }),
  loadProcessEngineJobsSuccess: (jobs: {
    [key: string]: FieldProcessEngineJob;
  }): LoadProcessEngineJobsSuccessAction => ({
    type: LOAD_PROCESS_ENGINE_JOBS_SUCCESS,
    payload: {
      jobs,
    },
  }),
};

export default visioCropActions;
